import config from 'config';

export function getBasePath() {
  const protocol = config.neptuneApiSecure ? 'https' : 'http';

  return `${protocol}://${config.neptuneApiBasePath}:${config.neptuneApiPort}`;
}
